export const chainParameter = {
  '137': {
    chainId: `0x${Number(137).toString(16)}`, // A 0x-prefixed hexadecimal string
    chainName: 'Polygon Mainnet',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: [
      'https://polygon-rpc.com/',
      'https://rpc-mainnet.matic.network',
      'https://matic-mainnet.chainstacklabs.com',
      'https://rpc-mainnet.maticvigil.com',
      'https://rpc-mainnet.matic.quiknode.pro',
      'https://matic-mainnet-full-rpc.bwarelabs.com',
    ],
    blockExplorerUrls: ['https://polygonscan.com/'],
  },
  '80001': {
    chainId: `0x${Number(80001).toString(16)}`,
    chainName: 'Polygon Mumbai',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: [
      'https://matic-mumbai.chainstacklabs.com',
      'https://rpc-mumbai.maticvigil.com',
      'https://matic-testnet-archive-rpc.bwarelabs.com',
    ],
    blockExplorerUrls: ['https://mumbai.polygonscan.com'],
  },
  '1337': {
    chainId: `0x${Number(1337).toString(16)}`,
    chainName: 'Localhost 8545',
    nativeCurrency: {
      name: 'ETH',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['http://localhost:8545/'],
    blockExplorerUrls: ['http://localhost:8545/'],
  },
}

// Polygon Mainnet network ID 137
// Polygon Mumbai network ID 80001
// Hardhat network ID 1337

export const requiredNetworkID = '137'
export const contractAddress = '0x30E6D0b8238C812d8C5618D13281bCefbc9b2382'
